module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "CN"
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text1#toc5"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "CT",
    attrs: {
      "id": "toc_marker-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text1#toc5"
    }
  }, [_vm._v("Aesthetic Distance in Performance")])]), _vm._v(" "), _c('p', {
    staticClass: "H1AFTER",
    attrs: {
      "id": "toc_marker-4-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text1#toc6"
    }
  }, [_vm._v("Aesthetic Distance")])]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Distance ")]), _vm._v("in homiletics has its roots in aesthetics and speech performance. Noël Carroll delineates three helpful uses of the term “aesthetics.” The first is “aesthetics” in its broadest sense, roughly equivalent to “philosophy of art.” Carroll notes that even among philosophers the two terms are frequently interchangeable. A second, narrower use of the term refers to the artistic properties of a work of art or a performance. These properties may be identified as expressive: for example, the artwork was “unified,” “graceful,” “elegant,” or “brittle.” We might use anthropomorphic terminology, such as “sad” or “somber.” Although these properties are considered part of the work itself, they are still response-­dependent because they are ascribed to the hearer or viewer."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-1",
      "id": "footnote-1836-1-backlink"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("It is the third use of the term that pertains to distance. Here “aesthetics” derives its meaning from the Greek word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("aisthēsis, ")]), _vm._v("which includes “sense perception,” or “sensory cognition,” in its definition. In the middle of the eighteenth century, theorist Alexander Gottlieb Baumgarten (1714-1762) first used the name for the modern discipline of “aesthetics” in his dissertation “Philosophical Reflections on some matters pertaining to Poetry.” Here Baumgarten describes “aesthetics,” the philosophical study of art, as “sense perception.” By emphasizing the senses, Baumgarten and other theorists who followed him made a significant shift from the philosophy of art in general toward the “addressed spectators” and their “reception” of the work. Whereas aesthetics as the philosophy of art is “object-­oriented,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("aesthetic ")]), _vm._v("as response-­dependent or sense perception is “reception-­oriented.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-2",
      "id": "footnote-1836-2-backlink"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY-L1"
  }, [_vm._v("In this third sense, “aesthetic” is often used as an adjective, such as “aesthetic experience,” “aesthetic perception,” “aesthetic attitude,” or “aesthetic distance.” When philosophers or theorists use “aesthetic” as a modifier, they signal intent in the interaction between the artwork and reader, listener, and viewer. In this sense, “aesthetic attitude” as a part of an “aesthetic experience” describes commonly recurring responses to art and performance. Approached with an aesthetic attitude, an aesthetic object has the function of being the proper locus of appreciation and criticism (criticism understood to include description, interpretation, and evaluation). The concept of an aesthetic object has a “normative function,” for it is supposed to guide our attention to the qualities of art and nature that are “aesthetically relevant” — and thereby serve as a foundation for criticism."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-3",
      "id": "footnote-1836-3-backlink"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("As a form of aesthetic experience, “aesthetic distance” is a particular kind of recurring response to performance involving the artwork and the perceiver. As part of an aesthetic attitude, aesthetic distance can be described as responses that occur when people distance themselves from an object they perceive, suspend their desires and other feelings, and are left with the mere experience of contemplating it."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-4",
      "id": "footnote-1836-4-backlink"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Psychical Distance")]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH-L1"
  }, [_vm._v("Long before the terms “distance” or “aesthetic distance” were coined, scholars and philosophers were discussing forms of distance and aesthetic distance. Perhaps the greatest figure in the interpretation of the beholder’s response in art was Immanuel Kant (1728-1804). His work "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Critique of Judgment ")]), _vm._v("(1790) greatly influenced a modern understanding of aesthetic experience by analyzing the contemplation of an aesthetic object as being “disinterested.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-5",
      "id": "footnote-1836-5-backlink"
    }
  }, [_vm._v("5")])]), _vm._v(" Kant divides his discussion of a theory of beauty, “Analytic of the Beautiful,” into four parts, each of which covers a major concept: disinterestedness, universality, the form of purpose, and necessity. George Dickie concisely summarizes the components of Kant’s theory in a sentence: “A judgment of beauty is a disinterested, universal and necessary judgment concerning the pleasure which everyone ought to derive from the experience of form.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-6",
      "id": "footnote-1836-6-backlink"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Under the heading “The Liking That Determines a Judgment of Taste is Devoid of All Interest,” Kant discusses disinterestedness: “Everyone has to admit that if a judgment about beauty is mingled with the least interest then it is very partial and not a pure judgment of taste. In order to play the judge in matters of taste, we must not be in the least biased in favor of the thing’s existence but must be wholly indifferent about it.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-7",
      "id": "footnote-1836-7-backlink"
    }
  }, [_vm._v("7")])]), _vm._v(" Kant continues by explaining “indifference” as a “pure disinterested liking that occurs in a judgment of taste.” According to M. H. Abrams, Kant’s understanding of disinterested contemplation is where the experience of the art object is independent of one’s personal interests and desires, and free from reference to the object’s reality, moral effect, or utility."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-8",
      "id": "footnote-1836-8-backlink"
    }
  }, [_vm._v("8")])]), _vm._v(" For Kant, fine art was a free creation of beauty with its own intrinsic value and worth. Through disinterested contemplation, people could enjoy beauty and design simply for their own sake.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY-L1"
  }, [_vm._v("Influenced by Kant’s understanding of “disinterested contemplation,” Edward Bullough (1880-1934) was the first in the twentieth century to formulate the term “Distance” as an aesthetic response to a work of art."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-9",
      "id": "footnote-1836-9-backlink"
    }
  }, [_vm._v("9")])]), _vm._v(" His seminal article “ ‘Psychical Distance’ as a Factor in Art and an Aesthetic Principle,” originally published in 1912 in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("British Journal of Psychology, ")]), _vm._v("has been reprinted extensively and discussed widely in most twentieth-­century and contemporary compilations of aesthetic criticism."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-10",
      "id": "footnote-1836-10-backlink"
    }
  }, [_vm._v("10")])]), _vm._v(" His influence in introducing “Distance” as a defining factor in aesthetic attitude and aesthetic experience cannot be overestimated. As Susanne Langer says in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Feeling and Form, ")]), _vm._v("Bullough’s article is “deservedly famous.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-11",
      "id": "footnote-1836-11-backlink"
    }
  }, [_vm._v("11")])]), _vm._v(" Even George Dickie, one of Bullough’s harshest critics, claims that the article “has almost become an article of faith for much present-­day aesthetic theory.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-12",
      "id": "footnote-1836-12-backlink"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("A professor of Italian at Cambridge University, Edward Bullough relied on his encyclopedic background in the arts and sciences, as well as his personal experience with theater, music, painting, sculpture, and architecture, to characterize a mental process necessary for experiencing art. Bullough noted a “dual attachment” in the perception of art that involved the interplay between “devotion” and a kind of “detachment impossible to obtain, performed for the sake of further ends of ulterior reason” (p. 67)."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-13",
      "id": "footnote-1836-13-backlink"
    }
  }, [_vm._v("13")])]), _vm._v(" This simultaneous attachment and detachment, separation and involvement, Bullough labels “Distance.” He declares: “Distance . . . is obtained by separating the object and its appeal from one’s own self by putting it out of gear with practical needs and ends” (p. 96).")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Bullough begins his article by differentiating the concept of Distance from other forms of distancing devices in connection with a work of art. “Spatial distance” is literally the measurable space between the “spectator” (Bullough’s term) and the work of art. “Represented spatial distance” is distance portrayed or represented in the work itself, for example, a painting of a tree that is portrayed at a distance on the horizon. In painting, this form of distance involves “perspective.” A third and more metaphorical form is “temporal distance,” which involves the remoteness of art from us in a particular point of time. Whereas all of these forms of distance, whether of space or time, may enhance simultaneous separation and involvement, they derive any aesthetic qualities they possess from “Distance” understood in its broadest connotation, which Bullough calls “Psychical Distance” (pp. 93-94).")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("As an example of psychical Distance, Bullough surprisingly uses an illustration from nature instead of art. He asks us to imagine a fog at sea. For most, such a natural phenomenon would be an experience of acute unpleasantness, producing feelings of anxiety and fear, straining our sight and hearing for dangerous objects and audible warnings. Its silence and gentleness makes the fog all the more terrifying. The expectant, tacit anxiety and nervousness associated with this experience is what makes fog a dreaded “terror of the sea” (pp. 93-94).")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Bullough then observes that at the same time sea fog can be an intense source of relish and enjoyment. By momentarily abstracting from the experience (what phenomenologists would call “bracketing out”) its danger and practical unpleasantness, we can now look at the phenomenon “objectively,” focusing on and appreciating the features that make up sea fog: its milklike opaqueness, the creamy smoothness of the water, “hypocritically denying,” as it were, any suggestion of danger (p. 94). The result is a “concentrated poignancy and delight” that momentarily switches on to contrast sharply with the “blind and distempered anxiety” of fog’s other aspects. Like watching some impending catastrophe with the unconcern of a spectator, our “practical interests” snap like a wire from pure “overtension” (p. 94).")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("This immediate and momentary change of outlook is due to what Bullough calls the “insertion” of Distance between our “own self” and the self’s “affections.” Bullough uses the term “affections” in its broadest sense as anything that affects our being. Thus sea fog becomes an illustration of how Distance is produced when apprehending nature or art by putting the phenomenon “out of gear” with the “practical, actual self.” Whether in fog, in a painting, or in a play, Distance occurs “by allowing [the self] to stand outside the context of our personal needs and ends — in short, by looking at it ‘objectively,’ as it has often been called, by permitting only such reactions on our part as emphasize the ‘objective’ feature of the experience, and by interpreting even our ‘subjective’ affections not as modes of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("our ")]), _vm._v("being but rather as characteristics of the phenomenon.” Paradoxically, Bullough’s search for what made art appear close and intense led him to Distance (p. 95)."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-14",
      "id": "footnote-1836-14-backlink"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("The distanced view of things cannot be our “normal” outlook, since it comes to us as a view of things from their reverse, usually unnoticed, side. Bullough proposes that Distance, therefore, has a “negative, inhibitory aspect” that cuts out the practical side of things and our practical attitude toward them. Simultaneously, Distance has a “positive side” by providing an experience of the new based on Distance’s inhibitory action. For Bullough, this experience of the new that comes upon us as a revelation is a factor of all art, “for distance, once it has occurred, can be aesthetically appreciated” (p. 95).")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("The heart of Bullough’s aesthetic is that Distance comes between our own self and its affections, whereby we can experience in a new way the work of art or performance. Bullough says: “Distance, as I said before, is obtained by separating the object and its appeal from one’s own self, by putting it out of gear with practical needs and ends. Thereby the ‘contemplating’ of the object becomes alone possible” (p. 96). Bullough goes on to say that this relationship between the self and the object may be broken, but not to the extent of being “impersonal.” For Bullough, Distance is not an impersonal, objective, or purely intellectual exercise; it describes a “personal relation” that is “highly emotionally coloured.” What is peculiar to the character of Distance, Bullough says, is that the personal character of the relation has been filtered, “cleaned of the practical concrete nature of its appeal without, however, losing its original constitution” (p. 97). Bullough gives as an example our attitude toward the events and characters in a drama: “They appeal to us like persons and incidents of normal experience, except that the side of this appeal, which would usually affect us in a directly personal manner, is held in abeyance. The difference, so well known to us as to be almost trivial, is generally explained by reference to the knowledge that the characters and situations are ‘unreal’ imaginings” (pp. 97-98)."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-15",
      "id": "footnote-1836-15-backlink"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY-T1"
  }, [_vm._v("Here Bullough notes an important paradox. One would think that Distance, by changing our perception and relationship to characters onstage, would render them as “fictitious,” thereby altering our feelings toward them. However, he goes on to observe that, paradoxically, the opposite is true: “Distance, which primarily gives to the action the appearance of unreality and not vice versa, is the observation that the same filtration of our sentiments and the same seeming unreality of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("actual ")]), _vm._v("men and things occur, when at times, by a sudden change of inward perspective, we are overcome by the feeling that ‘all the world’s a stage’ ” (p. 98). This personal but distant relationship is what Bullough calls “the antinomy of Distance” (p. 99)."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-16",
      "id": "footnote-1836-16-backlink"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("For Bullough, Distance is a psychological state that can either be achieved or lost. Distance can be lost through “underdistancing” or “over­distancing”: “The consequence of a loss of distance through one or other cause is familiar: the verdict in the case of underdistancing is that the work is ‘crudely naturalistic,’ ‘harrowing,’ repulsive in its ‘realism.’ An excess of Distance produces the impression of improbability, artificiality, emptiness or absurdity” (p. 101). The percipient may experience a response to an “underdistanced” performance as discomfort, fear, uneasiness, embarrassment, whereas the response to an “overdistanced” performance may take the form of apathy or incredulity."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-17",
      "id": "footnote-1836-17-backlink"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("To provide examples of how a performance can be underdistanced or overdistanced, Bullough returns to the theater. His first comedic example is when a “yokel” in the audience becomes so involved with the dangerous peril of a play’s heroine that he leaps onto the stage to assist her. Distance is restored when the audience publicly reminds him that it’s only a play. Bullough’s second example is more psychological. Here he presents an “underdistanced” response from a man who arrives for the performance of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Othello ")]), _vm._v("already suspicious and jealous concerning his wife. By a sudden reversal of perspective, he no longer sees a play or even a character named Othello, who apparently is betrayed by Desdemona; instead, he sees himself and his wife, and he thereby loses the necessary Distance (p. 99).")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("The same performance of Othello can provide an example of over­distancing: the thought processes of a drama expert and theater critic who are consumed by their “practical” activities. The result is a lack of emotional engagement. The same holds true of the audience member who, due to lack of experience with the theater or having no choice in attending the performance, concentrates on elaborate costumes and changing scenery. Such a perceptor is more impressed by the mechanics of the play and thus fails to comprehend or become involved in the actions of Othello, Desdemona, and Iago. These audience members could be described as lacking in imagination, involvement, and engagement by focusing on the “practical” aspects of the total work."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-18",
      "id": "footnote-1836-18-backlink"
    }
  }, [_vm._v("18")])]), _vm._v(" Because they were overdistanced, viewers who might have engaged with the drama were instead denied an aesthetic response. Both underdistancing and overdistancing can cause a loss of Distance and a loss of the possibility of an aesthetic experience. For Bullough, failure to distance is synonymous with failure to participate and appreciate.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Distancing Techniques")]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("Bullough identifies four components of art: the artist, the setting, the art object and its presentation, and the “perceptor,” each having distinct distancing capabilities and characteristics. Using Bullough’s example of the theater, we can see how Distance could be achieved through the distancing capabilities of these components: the actor, the theater, the play, and the audience.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY-T1"
  }, [_vm._v("For Bullough, the primary responsibility of the creative process begins with the artist, in this case the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("actor, ")]), _vm._v("whose “artistic production is the indirect formulation of a distanced mental context” (p. 115). The actor uses several factors to achieve Distance, such as costume and makeup, a trained voice, and stylized gestures. Distancing qualities of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("setting ")]), _vm._v("would include “setting apart” the drama by lifting it up with a raised platform, framing it with a proscenium, and artificial lighting. Temporal distance may be achieved by the use of properties and scenery from a remote period.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Most important to Bullough’s achievement of Distance is the art object’s “formal” qualities. In the theater this would include symmetry, opposition, proportion, balance, and rhythm in the overall composition of the drama and its presentation through staging and direction."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-19",
      "id": "footnote-1836-19-backlink"
    }
  }, [_vm._v("19")])]), _vm._v(" Usually symmetry, proportion, and balance onstage are not considered distancing factors, but rather a part of composition whereby the work is made intelligible and enjoyable. In contrast, Bullough says: “For, every kind of visibly intentional arrangement of unification must, by the mere fact of its presence, enforce Distance, by distinguishing the object from the confused, disjointed and scattered forms of actual experience” (pp. 105-6). Because Distance comes between our own affections and the work of art, it takes qualities such as symmetry and balance and removes them from the disorganized chaos of the everyday world.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("For the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("audience member ")]), _vm._v("at the play, the ability to achieve Distance would come via preparation and frequent encounters with theater. Bullough insists that a perceptor could cultivate Distance. For the under­distanced husband who sees "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Othello ")]), _vm._v("as an extension of his marital problems, awareness of the plot or the mechanics of the play itself could help him put this role aside. The overdistanced theater critic might benefit from an intentional to-­and-­fro movement — from emotional engagement to the critical distanced attitude.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("The more the object becomes stylized, unrealistic, and isolated either by its own properties or through presentation, Distance correspondingly increases. As the perceptor adopts a less personal or emotionally involved posture with respect to the object or its presentation, Distance proportionally increases. Because of the “variability” of its components, Distance is not a fixed point but a continuum with “naturally changing degrees,” depending on the art object, the recipient, and the presentation. Even so, Bullough makes clear his preference for the greatest aesthetic experience with the most intense and meaningful results: “What is, therefore, both in appreciation and production, most desirable is the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("utmost decrease of Distance without its disappearance")]), _vm._v("” (p. 100; italics added).")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Critics of Psychic Distance")]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("As the discipline of aesthetics was being redefined in the mid-­twentieth century, aesthetic attitude theory was challenged, and thus Distance as an aesthetic principle was scrutinized. Criticism of Bullough’s low-­distance aesthetic came from both sides of the spectrum. José Ortega y Gasset rejected low-­distance art as being “human, all too human,” in favor of stylistic, highly distanced art that serves as an “early warning system to society and culture.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-20",
      "id": "footnote-1836-20-backlink"
    }
  }, [_vm._v("20")])]), _vm._v(" At the same time, Bullough’s aesthetic was also challenged by a strong countermovement to dehumanization, the goal of which was to break down Distance altogether. Bullough promoted a low-­Distance art that was most desirable for “both appreciation and production”; yet he was against its disappearance altogether. He criticized such underdistanced work for referring to the body, sexuality, relevant and sensational topics of the day, and for expressing doubt as to the validity of social institutions. What Bullough condemned in the countermovement, experimental theater embraced. It emphasized "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("engagement, ")]), _vm._v("the intent to “break down the distance between artist and public, actor and audience, the work of art and the beholder.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-21",
      "id": "footnote-1836-21-backlink"
    }
  }, [_vm._v("21")])]), _vm._v(" Ironically, while this movement adamantly rejected Bullough’s concept of Distance, its art was dependent on the function of Distance as a force to be continually broken down and destroyed in performance.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY-L1"
  }, [_vm._v("George Dickie, one of Bullough’s strongest critics, claims that “aesthetic attitude theories” have run their course and no longer have theoretical value for aesthetics. In “All Aesthetic Attitude Theories Fail,” he quotes Gilbert Ryle to that effect: “Myths often do a lot of theoretical good while they are new,” but aesthetic attitude in general and psychic distance in particular are “no longer useful and in fact mislead aesthetic theory.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-22",
      "id": "footnote-1836-22-backlink"
    }
  }, [_vm._v("22")])]), _vm._v(" Dickie refers to Bullough’s examples from the theater in which audience members were either underdistanced or overdistanced from the work of art. Using his own experience as an audience member, Dickie chides Bullough for confusing Distance with “intentions,” thereby attempting a general theory of aesthetics based on an inattentive audience member. Dickie sums up what he calls Bullough’s fallacy: “[S]ubstantive guidelines for art criticism and appreciation can be derived from the nature of a certain kind of psychological state. If there is no such psychological state, this approach is in serious difficulty.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-23",
      "id": "footnote-1836-23-backlink"
    }
  }, [_vm._v("23")])]), _vm._v(" More recently, Noël Carroll has also refuted Distance as an “experience aesthetic,” affect-­oriented and relying on the concept of disinterested attention. Drawing the same conclusions as does Dickie, she observes: “But upon scrutiny, this concept appears inadmissible, since it confuses motivation with attention. This suggests that the affect-­oriented account of aesthetic experience is a dead end.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-24",
      "id": "footnote-1836-24-backlink"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("While Bullough’s foremost attempt was to provide an overall aesthetic based on Distance, he is better known today for his introduction of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("distancing characteristics, ")]), _vm._v("or dynamics, in the four components of a work of art: the artist, the art object and its presentation, the spatial and temporal setting, and the perceptor or audience. The influence of what would later be called “distancing devices” in contemporary speech and performance cannot be overstated. Even Bullough’s harshest critics, such as George Dickie, agree that Bullough’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dynamics of Distance, ")]), _vm._v("especially with regard to the four components of a work of art, continue to be a significant influence in the performing arts and literature. M. H. Abrams observes that, in recent criticism, “the term "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("aesthetic distance, ")]), _vm._v("or simply "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("distance, ")]), _vm._v("is often used not only to define the nature of literary and aesthetic experience in general, but also to analyze the many devices by which authors control the degree of a reader’s distance, or ‘detachment’ — which is in inverse relationship to the degree of a reader’s involvement, or ‘concern’ — with the actions and fortunes of one or another character represented within a work of literature.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-25",
      "id": "footnote-1836-25-backlink"
    }
  }, [_vm._v("25")])]), _vm._v(" The dynamics of the relationship between distance and involvement for the reader/hearer/audience has been Bullough’s legacy to contemporary speech performance and preaching.")]), _vm._v(" "), _c('p', {
    staticClass: "H1",
    attrs: {
      "id": "toc_marker-4-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text1#toc7"
    }
  }, [_vm._v("Performing Distance")])]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("It is no coincidence that contemporary homileticians who discuss distance in preaching, notably Jana Childers and Charles Bartow, share a speech and performance-­studies background. In the remainder of this chapter, I will investigate distance in speech performance by tracing its use in the disciplines of elocution, oral interpretation, presentational theater, and literary criticism that focuses on the reader as performer. With an eye toward preaching, I develop the following proposal: Distance between audience, performer, and text is integral to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("engagement of the hearer ")]), _vm._v("in the performance as an event."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-26",
      "id": "footnote-1836-26-backlink"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Distance and Delivery: Elocution")]), _vm._v(" "), _c('p', {
    staticClass: "TP"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Troilus . . .")]), _c('br'), _vm._v("\tMy will enkindled by mine eyes and ears,"), _c('br'), _vm._v("\tTwo traded pilots ’twixt the dangerous shores"), _c('br'), _vm._v("\tOf will and judgment. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "TC-CLOSE para-style-override-2"
  }, [_vm._v("William Shakespeare,"), _c('br'), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Troilus and Cressida, ")]), _vm._v("II.ii.61-65"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-27",
      "id": "footnote-1836-27-backlink"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("In “The Dangerous Shores: From Elocution to Interpretation,” Wallace Bacon uses Shakespeare’s image of “dangerous shores” as a metaphor for a polarity in performance where “delivery” is on one shore and “text” is on the other (pp. 148-52). While Troilus’s dichotomy was between judgment and the will as “enkindled” by the senses of sight and sound, Bacon observes a similar dichotomy in theories of performance where the double character of the subject (text and delivery) can be stated in a series of compounds: reason-­passion, logic-­emotion, scholarship-­entertainment, content-­delivery, natural-­mechanical, and — especially germane to this project — "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("text-­audience. ")]), _vm._v("Bacon declares: “Too much interest in the audience is as bad as too exclusive interest in text — another way of looking at the dangerous shores” (p. 151).")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("For Bacon, all these bifurcations simply underscore the dilemma that “exists, has always existed, and always will exist” in the performance of texts: “The whole art consists, has always consisted, and always will consist in a union of the two elements. It has not in the long run worked to overlook the basic and determining character of the text being read; neither will it work to overlook the essential significance of the oral performance” (p. 150). According to Bacon, the history of the performance of texts has always involved the interplay between text and delivery; yet different schools of thought at different times have emphasized one over the other. Continuing Bacon’s metaphor, the emphasis of the elocutionary movement lands it on the “shore” of delivery.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Elocution is best known as a speech movement and part of a liberal education in eighteenth-­ and nineteenth-­century England and America. Although elocution is often associated with public speeches and performances of literature for inspiration and entertainment, its roots are liturgical, going back to the delivery of sermons in the seventeenth century."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-28",
      "id": "footnote-1836-28-backlink"
    }
  }, [_vm._v("28")])]), _vm._v(" “Elocution” is derived from classical rhetoric’s term "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("elocutio, ")]), _vm._v("usually interpreted as the style of the speaker’s composition. The change in meaning of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("elocutio ")]), _vm._v("from the “style” of the composition to “delivery” is often attributed to John Mason’s “Essay on Elocution,” published in 1748. However, a hundred years earlier, clergyman John Wilkins had used the term for the delivery of sermons. In his essay "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ecclesiastes, or, A Discourse concerning the Gift of Preaching, ")]), _vm._v("published in 1646, Wilkins uses the term to note a shift from the sermon’s style, according to classical rhetoric, to the preacher’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("actio, ")]), _vm._v("or “delivery,” best suited to the office of preacher. He says, “The most proper manner of eloquution is with modesty and gravity, which will best sute with our calling and businesse.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-29",
      "id": "footnote-1836-29-backlink"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY-T2"
  }, [_vm._v("In his eight famous lectures delivered in London in 1762, Thomas Sheridan, actor, elocutionist, and son of an Anglican theologian and preacher, defined “elocution” as “the just and graceful management of the voice, countenance, and gesture in speaking.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-30",
      "id": "footnote-1836-30-backlink"
    }
  }, [_vm._v("30")])]), _vm._v(" His lectures were mainly concerned with pronunciation, accent, emphasis, tones, pauses, pitch, and gesture. Particularly related to the emotions were tones and gesture. According to Sheridan, tones were the audible aspects of emotion, and gestures were the visible aspects of emotion. Each passion had its own corresponding tone and peculiar look or gesture with the body. All the other elements of delivery were related particularly to the expression of ideas (Bacon, p. 148).")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Throughout the eighteenth and greater part of the nineteenth centuries, “elocution” referred to effective speaking and the delivery of spoken forms of discourse. It became “the art of expressive thought by speech” and was later defined as the “Art of expressing thought and feeling by means of Voice and Action.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-31",
      "id": "footnote-1836-31-backlink"
    }
  }, [_vm._v("31")])]), _vm._v(" Though elocution emphasized the elements of delivery according to their corresponding emotions and ideas, it was not at the expense of meaning in the act of speaking. Bacon observes: “The eighteenth-­century term elocution embraced not alone the classical concept of ‘style of composition,’ but the whole conveyance of meaning through style of composition "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("delivered")]), _vm._v("” (p. 149)."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-32",
      "id": "footnote-1836-32-backlink"
    }
  }, [_vm._v("32")])]), _vm._v(" By today’s standards, corresponding elements of delivery with particular emotions and thought and their subsequent codification may seem mechanical and contrived. Charles L. Bartow notes that, whereas today the term “elocution” might evoke “guffaws,” in the mid-­eighteenth century, elocution, at its best, referred to “the management of voice and body in the speaking of texts and in the presentation of formal addresses.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-33",
      "id": "footnote-1836-33-backlink"
    }
  }, [_vm._v("33")])]), _vm._v(" Whereas today’s dictionary may define the term in a derogatory sense as a “stilted, artificial manner of delivery,” Bartow reminds us that the Latin origin of the word simply means to “speak out,” and in classical rhetoric, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("elocutio ")]), _vm._v("was “a speaker’s distinctive way of bringing thought to expression.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-34",
      "id": "footnote-1836-34-backlink"
    }
  }, [_vm._v("34")])]), _vm._v(" The external elements of delivery were not an imposition but part of a conventional and normative view. Although the emphasis was on performance, this view recognized “sense” as the determining event from which all passions in delivery must arise and be fixed (Bacon, pp. 148-52)."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-35",
      "id": "footnote-1836-35-backlink"
    }
  }, [_vm._v("35")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("A number of influences combined to bring about the demise of elocution in the latter part of the nineteenth century. One factor was its being severed from the delivery of all forms of spoken discourse to being associated essentially with reading aloud or simply “performing.” As a result, elocution lost contact with the canons of rhetoric pertaining to speeches, sermons, and literature, and thus delivery became divorced from content. A second factor was elocution’s abandonment of the theories and philosophies of its early writers for the mysticism of the time in America, especially influenced by the theories of Delsarte. When text and “sense” had been severed from delivery, it was replaced with a mystical absorption into nature or other forms of art, what Bullough described as crudely naturalistic, harrowing, and repulsive, without distance between the work and the performer. Since there was no longer a text to be delivered, “expression” became “possession,” producing performances that had degenerated into bird calls, imitations of children, or statue-­posing."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-36",
      "id": "footnote-1836-36-backlink"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("A third factor for the movement’s falling from grace was that elocution had become an idiosyncratic “art unto itself.” Materials were being written and performed for no purpose other than displaying the oratorical versatility of the speaker. Symbolic of this shift to the performer was the tacking on of the suffix “ist” to “elocution”: no longer designated as “readers” or “speakers” (terms that imply a text, speech, or even sermon), performers were now called “elocutionists,” practitioners of the art of delivery with nothing to deliver."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-37",
      "id": "footnote-1836-37-backlink"
    }
  }, [_vm._v("37")])]), _vm._v(" Performers performed themselves. Preachers preached their delivery.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Although the emphasis in elocution had been on “expression,” there was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("something ")]), _vm._v("to be expressed. When elocution became separated from text, what remained were the mechanics and spectacle of the elocutionist and the effect on the audience (or congregation). Returning to Wallace Bacon’s opening metaphor of the two shores, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("distance ")]), _vm._v("between the text and performer had collapsed. Without a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("text, ")]), _vm._v("elocution crashed into the dangerous shore of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("delivery, ")]), _vm._v("and there met its demise.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Distance and Text: Oral Interpretation")]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH-L2"
  }, [_vm._v("In the twentieth century, elocution was followed by the modern discipline of “oral interpretation,” later called “interpretation.” Both disciplines involved the performance of texts, yet each with a different emphasis. Thomas Sheridan defined elocution as “the just and graceful management of the voice, countenance, and gesture in speaking” (Bacon, p. 149); by contrast, Wallace Bacon defined “interpretation” in 1959 as “the study of literature through the medium of oral performance” (pp. v-­ix, 149)."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-38",
      "id": "footnote-1836-38-backlink"
    }
  }, [_vm._v("38")])]), _vm._v(" Bacon notes that it is important to underscore that both definitions reveal interest in the fundamental contributions of the oral performance and in neither is literary appreciation viewed apart from delivery. But when the two are compared, Sheridan’s definition of elocution uses the text as a point of departure, whereas Bacon’s definition of interpretation uses the text as a point of return. According to Bacon, this seems to be the clear line of change from the eighteenth century to the mid-­twentieth century regarding the teaching and practice of oral reading (p. 149).")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("In contrast to the later elocutionists, who emphasized technique and its effect on the audience, interpretation in the 1950s was moving in the direction of the “thing read,” not in the direction of the “person reading.” This is not to say that participation on the part of the performer (or audience) was not important. What was important was the participation "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("in the life of the text. ")]), _vm._v("For the oral interpreter, understanding is necessary for participation; yet participation through performance creates a new understanding of the text. Whether this understanding is deliberate or intuitive, it involves knowledge (p. 150).")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("In “The Dangerous Shores,” Bacon lists three things involved in the interpretation process: the text (“the interpreter’s excuse for being”), audibility, and aliveness (pp. 148-52)."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-39",
      "id": "footnote-1836-39-backlink"
    }
  }, [_vm._v("39")])]), _vm._v(" The latter two involve the performer and the audience. In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Art of Interpretation, ")]), _vm._v("Bacon contrasts the oral interpreter to the silent reader, observing that the unique function of the interpreter is to create a “presence” and to create it so fully that it can contain and involve an audience."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-40",
      "id": "footnote-1836-40-backlink"
    }
  }, [_vm._v("40")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Presence ")]), _vm._v("is not the text acting on the interpreter alone or the interpreter acting on the text alone, but the dialogic yielding of their interaction. In response to Bacon’s “shores” of text on the one hand and delivery on the other, Alla Bozarth-­Campbell observes that the art of interpretation is always “balanced, dynamically poised between these two constituents.” Describing Bacon’s understanding of interpretation, Bozarth-­Campbell says:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("Balance consists in the union of logic and emotion, reason and passion, and so on, which is to be determined, not by the idiosyncratic performer, but solely by the “determining character of the text.” This union implies participation in the life of the text — participation that follows from understanding. The art of interpretation, according to this position, is “an art of enactment, of embodiment, of becoming. The poem is active, the reader active; the art of interpretation aims at establishing in oral performance a congruence between these two sets of acts.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-41",
      "id": "footnote-1836-41-backlink"
    }
  }, [_vm._v("41")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("In interpretation, the oral performance of texts, the interpreter’s goal is to achieve a “balance” between text and performer, and between performer and audience. The dynamic necessary to preserve this balance is identified as distance.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Distance and Modes")]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("Distance has long been a subject of discussion and research in interpretation theory and pedagogy. Wallace Bacon and Leland H. Roloff have identified the dynamics of distance within the text according to the “modes” of literature. Modes refer to classifications of literature based on the voice of the author in the text. In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Art of Interpretation, ")]), _vm._v("Bacon suggests that the identification of “modes” attempts to get at matters of perspective, locus, and presence. Based on Aristotle’s classification of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lyric, dramatic, ")]), _vm._v("and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("epic, lyric ")]), _vm._v("is the mode in which the author speaks, or seems to speak, in his or her own voice and stands in the closest and most immediate relationship to the audience. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Epic ")]), _vm._v("is the mode in which the speaker functions as a narrator, sometimes speaking in his or her own voice directly to the audience and at other times through the voice of others — in which the characters seem to speak for themselves."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-42",
      "id": "footnote-1836-42-backlink"
    }
  }, [_vm._v("42")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dramatic ")]), _vm._v("is the mode in which the voice of the author — or what we may take to be the author’s voice — is entirely submerged into the voice of characters. For Bacon and Roloff, modality cuts across all literary genres and is based on the distant/near and direct/indirect relationship between the author and text as faithfully presented by the performer to the audience."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-43",
      "id": "footnote-1836-43-backlink"
    }
  }, [_vm._v("43")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("All three modes can be seen in Scripture. A Pauline epistle is lyric, with direct address that provides a close relationship between the author and the hearer, whereas the Gospel of Mark is epic: the author sometimes speaks directly to the audience and at other times through the voice of characters. In the Bible, as in other texts that are a product of redaction and compilation, the dramatic mode may take on a different modality depending on the author and the context. For example, the song of Miriam may have been lyric, but it becomes epic when put in the context of the book Exodus’s story.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Distinctions between modes become even less clear when texts are performed. No longer can a particular mode be identified according to the “nearness” or “distance” of an author or implied author. In performance, nearness and distance do not necessarily correspond to lyric/epic/dramatic. The performed voice in the lyric mode may be distant and introspective, giving the audience a look into the speaker’s inner thoughts; or the performer might directly address the audience members and draw them "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("near ")]), _vm._v("with the intensity of eye contact and “open focus.” The same holds true of the dramatic mode, depending on whether or not the character is believable and compelling.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Even so, Roloff affirms that the relationship between the author’s voice and the text is what governs distance in performance. In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Perception and Evocation of Literature, ")]), _vm._v("he proposes that performance is guided by three main considerations:")]), _vm._v(" "), _c('p', {
    staticClass: "LN-1ST"
  }, [_vm._v("\t1.\tThe aesthetic distance in performance is determined by the literature and not by the performer.")]), _vm._v(" "), _c('p', {
    staticClass: "LN"
  }, [_vm._v("\t2.\tThe performer is the source of the aesthetic enjoyment, not the literature. Here he refutes the theory that literature is some kind of abstract “object” that exists between the performer and audience.")]), _vm._v(" "), _c('p', {
    staticClass: "LN-LAST"
  }, [_vm._v("\t3.\tThe audience may, and usually does, hold the performer accountable for the interpretation as well as the mastery and control of the literary work.")]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("The performer determines appropriate distance by attending to the modality of the text through the use of intuition. According to Roloff, the sensitive reader or performer “apprehends or intuits the distance the work requires.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-44",
      "id": "footnote-1836-44-backlink"
    }
  }, [_vm._v("44")])]), _vm._v(" From these criteria, it is evident that the literature itself determines the distance between the performer and text.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("In recent years, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Art of Interpretation")]), _vm._v("’s criteria for distance in performance have been challenged as being based on an outmoded understanding of aesthetic distance. Following the rethinking of Bullough’s work in aesthetics, the wealth of material that was published in the 1940s on the principle of aesthetic distance in oral interpretation began to emphasize the process of distancing or distancing devices in the 1960s and 1970s. Beverly Whitaker Long presents a compelling argument that in mid-­century the predominant theory of aesthetic distance was based on a hermeneutic that perceived the text as being autonomous from the performer and the performance. Distance was required of the performer so that she or he would not absorb or violate the text and the “intentions” of the author. These intentions should be recognized according to the conventions used in the text. When placed on a continuum, distance increases when moving from left to right:")]), _vm._v(" "), _c('p', {
    staticClass: "C2"
  }, [_vm._v("conversation\trhythmical utterance"), _c('br'), _vm._v("prose\tverse"), _c('br'), _vm._v("colloquial speech\televated diction"), _c('br'), _vm._v("direct address\tdialogue between characters"), _c('br'), _vm._v("topical subjects\timaginative subjects")]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("The correct form of distance between performer and audience depended on the location of the conventions of speech on the above continuum. Various diagrams were created by which a genre of performance could be “scientifically” located and defined according to “aesthetic distance.” Drama, for example, required less distance from the actor to the play and more distance to the audience, whereas oral interpretation or the “reading aloud” of a piece required greater distance between reader and text and less between text and audience. When the use of distance did not match these conventions, the “intention” of the text was considered violated and the performance was deemed unsuccessful."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-45",
      "id": "footnote-1836-45-backlink"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("In the 1970s, a scientific approach to distance in performance disappeared when its underlying principles gave way to a “New Hermeneutic.” No longer could “distance” define strict genres. Charts plotting criteria for aesthetic distance disappeared when the New Hermeneutic claimed that the meaning of texts in performance was inseparable from the “pretexts” and “contexts” of performer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and ")]), _vm._v("audience.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Distance and the Audience: Presentational Theater")]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("Presentational performance can best be understood in contrast to its more modern counterpart, representational performance."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-46",
      "id": "footnote-1836-46-backlink"
    }
  }, [_vm._v("46")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Representational performance, ")]), _vm._v("or “representationalism,” is the theory and practice of drama that portrays or “represents” the real world and emphasizes the illusion of reality. In contemporary proscenium theater, it is staged as if a fourth wall has been removed and the audience is privy to the slice of life behind that wall. The characters appear as if they are not aware that they are being observed. Costumes, sets, staging, and technical aspects of the performance are not symbolic but accurate — or “realistic” to the setting and time period of the drama.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("In representational performance, actors do not present a character; they portray a role. They become the characters that they portray. Constantine Stanislavski (1865-1938), a master teacher of representational performance, taught actors to live their part outside of the performance in order to train the entire body. The aim was to reproduce accurately realistic emotional affect in performance. He says: “The actor lives his part only as a preparation for perfecting an external form. . . . Once that is determined he reproduces that form through the aid of mechanically trained muscles. . . . Living your role is not the chief moment of creation . . . but one of the preparatory stages for further artistic work.”")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("In representational drama, the imitation of form is as important as the content or the message of the play, for anything the audience perceives as less than accurate breaks the illusion of the created reality. For Stanislavski, “[t]he art of representation demands perfection if it is to remain an art.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-47",
      "id": "footnote-1836-47-backlink"
    }
  }, [_vm._v("47")])]), _vm._v(" Anything less distances the audience through distraction.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("For representational performance to be successful, the audience must participate in a “willing suspension of disbelief.” The English poet Samuel Taylor Coleridge (1772-1834) popularized that phrase — concerning the basis on which “poetic faith” operates in literature. In accordance with modern aesthetic theory, we approach literature with a sense of disbelief, knowing that the character and actions portrayed are not immediately real to us. Yet, because we want to participate in another reality — the world of the text or artistic creation — we voluntarily choose to suspend for the moment our disbelief and accept as “real” the artistic representation."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-48",
      "id": "footnote-1836-48-backlink"
    }
  }, [_vm._v("48")])]), _vm._v(" When applied to theater and performance, Coleridge’s “willing suspension of disbelief” is an explanation of our faith in the truth of a representation on a stage. The audience approaches the performance with an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("optique du théâtre ")]), _vm._v("( a “theater lens”), or, less literally, a “stage illusion” that serves as a reminder that at all times the play is fiction and not reality."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-49",
      "id": "footnote-1836-49-backlink"
    }
  }, [_vm._v("49")])]), _vm._v(" In order for the representational performance to be more than artifice — unreal and therefore “false” — the audience members suspend their disbelief and participate in the new reality being offered. The greater the actor’s and technician’s skill in creating the illusion of “real life,” the smaller the need for the audience’s “willing suspension of disbelief” in order for the performance event to be successful.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Representational theater was taken to the extreme at the turn of the twentieth century in France with the Théâtre Libre in Paris and in the United States with producers such as David Belasco."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-50",
      "id": "footnote-1836-50-backlink"
    }
  }, [_vm._v("50")])]), _vm._v(" Although both of these dramatic schools strove for absolute realism, to the point of real props and actors turning their backs to the audience, they could not overcome the predisposition of the audience entering the theater to know and expect that the world represented onstage was still a fiction. By virtue of its being a performance, representational drama is still always partly presentational.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY-T2"
  }, [_vm._v("In contrast to representational performance, the aim of presentational performance is not to imitate “real life” and therefore create an illusion, but to present for the audience a creative fictive world. In presentational performance, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("how ")]), _vm._v("the drama is portrayed is as important to meaning and experience as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("who ")]), _vm._v("or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("what ")]), _vm._v("of the play. Therefore, dramatic devices and artifice are not hidden for illusion’s sake but intentionally highlighted in performance for the sake of wonder, aesthetic pleasure, meaning, and reflection.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("In Western civilization, presentational performance has a long history that can be seen in the theatrical styles of Europe and traced back to the ancient Greek theater. For the Greeks, the role of the actor was symbolic, standing for and “suggesting” the actions of the gods and great mortals. Often the highlight of a festival in honor of a god, the ritual of the presentation focused on the audience’s belief not in the present and immediate illusion of reality but in the reenactment, interpretation, and thus meaning of the story. Especially when the story was well known, the Greeks were as much interested in the reenactment — and hence the aesthetic quality of the performance — as in the particular interpretation of one playwright in contrast to another. According to scholars, Greek audiences were curious about how stories of well-­known characters such as Orestes and Electra would be handled by Euripides compared to how Aeschylus would handle them. An emphasis on different interpretations fostered critical reflection by the audience on various meanings of the story with regard to religion, morality, and politics.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Greek theater used many nonrealistic dramatic devices that later flourished on the Elizabethan stage and can be presently seen in contemporary theater and performance. These presentational forms involve the stage, chorus, songs, narrator, and masks. In the Greek theater there was no imaginary fourth wall of the proscenium stage, but an amphitheater with a stage in the half-­ or three-­quarter-­round arrangement similar to the Elizabethan stage or the contemporary thrust stage. Compared to the contemporary proscenium theater, where the raising of the curtain invites us to observe through a fourth wall and enter inside the drama, the Greek stage and its contemporary offshoots thrust or project the world of the performance out into the audience, where they would participate and complete “suggested actions” in their own imaginations. The chorus played an important part in Greek theater, for it not only physically occupied the projected space of the stage but also projected its reflection onto the action and characters. The chorus provided commentary — sometimes "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("to ")]), _vm._v("the audience and at other times speaking "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("for ")]), _vm._v("the audience regarding the drama. Masks served not only to assist in vocal amplification and projection, but also amplified and projected in a “frozen gaze” the inner emotional state of a character that may have been externally restrained or concealed by a person in real life."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-51",
      "id": "footnote-1836-51-backlink"
    }
  }, [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("In presentational performance, all of these dramatic devices serve as distancing techniques between the performance and audience. Whereas representational theater encourages closeness and empathy with the characters and their situation, presentational performance encourages contemplation of the characters and dramatic action and their significance through "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("distancing ")]), _vm._v("the audience. When drama is represented, the audience observes and participates in the story; when drama is presented, the story becomes a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("part of ")]), _vm._v("the audience.")]), _vm._v(" "), _c('p', {
    staticClass: "H3"
  }, [_vm._v("Distancing Techniques")]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("Two of the most influential modern dramatists to make use of presentation conventions of distancing were Thornton Wilder (1879-1975) and Bertolt Brecht (1898-1956). In the plays of Thornton Wilder, the technique of distancing in the theater was to evoke wonder — wonder at the “enchantment of the theater’s power of illusion and wonder at the human condition as revealed in the theater.” Distancing also evoked a contemplation of values. Wilder observes in the preface to a collection of his plays: “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Our Town ")]), _vm._v("is not offered as a picture of life in a New Hampshire village; or as a speculation about conditions of life after death. . . . It is an attempt to find a value above all price for the smallest events in our daily life.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-52",
      "id": "footnote-1836-52-backlink"
    }
  }, [_vm._v("52")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Wilder promotes this contemplation of values and wonder of the human condition by distancing the audience from a particular setting in which the plot, characters, and action take place. Compared to the realistic settings, or “scenery,” of traditional representational theater, the set for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Our Town ")]), _vm._v("is made up of a few chairs, tables, and ladders that diminish as the play proceeds. A ladder becomes a wall, a tree, a stairway in a house, and even a metaphor for a vista of the heavens. By distancing the audience from a particular setting, says Wilder, “I have made a claim as preposterous as possible, for I have set the village against the larger dimension of time and place” (p. xi). Through this intentional separation of the play from the setting, along with the direct address of a “stage manager” narrator and the unconversational (or “unreal”) repetition of words such as “hundreds,” “thousands,” and “millions,” the play is presented to the audience and completed within the audience’s imagination. Wilder suggests: “Our claim, our hope, our despair are in the mind — not in things, not in ‘scenery’ . . . . [T]he climax of this play needs only five square feet of boarding and the passion to know what life means to us” (p. xii).")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Intentional distance through setting is a technique also found in Wil­der’s play "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Skin of Our Teeth. ")]), _vm._v("Beginning with the opening scene, the audience is forced to “back up” from the action of the play in order to make sense of the shifts in time and space. They soon recognize that they are observing a family living in two times at once: in prehistoric time and in a contemporary New Jersey commuter suburb. The audience is forced beyond empathy with particular characters to contemplation of the human condition — whence we came and whither we are going. Through the use of distancing devices, Wilder removes the usual theatrical distractions and raises to the attention of the audience the essential meaning of the drama. He clearly declares: “I am not an innovator but a rediscoverer of forgotten goods and I hope a remover of obtrusive bric-­a-­brac” (p. xi).")]), _vm._v(" "), _c('p', {
    staticClass: "H3"
  }, [_vm._v("Alienation Devices")]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("A dramatist who rediscovered presentational theater and took it in a new direction is Bertolt Brecht. Brecht’s “epic theater” has profoundly influenced twentieth-­century theater, both in theory and practice."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-53",
      "id": "footnote-1836-53-backlink"
    }
  }, [_vm._v("53")])]), _vm._v(" A noted feature of Brecht’s epic theater was his use of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Verfremdungseffekt ")]), _vm._v("(alienation, or “alienation devices”). Brecht was opposed to the traditional representational theater of his time, which promoted an illusion of reality. According to Brecht, the traditional play casts a “spell” over the audience, a spell in which the audience members are either mesmerized into a state in which time, space, and self-­awareness are suspended, or they are empathetically absorbed into the emotions of the characters and the pathos of the play. In either case, critical consciousness is lost. The audience would leave the theater entertained, moved, or individually pondering, but the audience as a whole was not transformed or moved toward action. Brecht criticized traditional theater’s supporting of the status and values of the middle and upper class through entertainment, emotional catharsis, and private transformation, while ignoring the public, social, and political power of performance."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-54",
      "id": "footnote-1836-54-backlink"
    }
  }, [_vm._v("54")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Vehemently opposed to this privatized experience of drama, Brecht used techniques that were boldly theatrical, whereby the audience was “alienated” or estranged from the illusion or emotions on stage. Whereas Thornton Wilder’s aim of presentational was “wonder” and the “pondering of the meaning of the human condition,” Brecht’s use of alienation devices created critical distance to evoke a critique of society and a transformation of the audience into a community of social action. To this social and political end, epic theater used songs, narration, episodic (nonsequential plotting of) scenes, and openly displayed theater devices and technology. A half curtain or no curtain at all, exposed lighting, and open changes of scenery served as a constant reminder that the audience members were not to get lost in the plot or the characters, that they were attending a production in order to think, learn and act.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Compared to Stanislavski’s method, in which actors were to display realistic emotion in a realistic way, Brecht’s actors broke the illusion by putting on and taking off roles and characters in front of the audience, much in the same way the ancient Greek actor would put on or take off a mask. One of the ways this device was used was to call the audience’s attention to the fact that in public life we all play different roles, and that those in political, religious, and economic power are to be suspected of playing theatrical deceptions. Characters were not to evoke empathy but critical distance.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Perhaps Brecht’s most powerful alienation device was the jarring use of visual aids. In the middle of an engaging scene or a moving dramatic monologue, the moment would be invaded by a film, slide, newspaper headline, or signboard that was dropped onto the stage and gave social commentary on the speech and actions of the play. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Saint Joan of the Stockyards ")]), _vm._v("(also translated as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Saint Joan of the Slaughterhouse) ")]), _vm._v("is set in the Chicago stockyards during the middle of a labor dispute involving management (“meat king”), meat packers, stockbreeders, brokers, the poor, the media, soldiers (the police), and officers of the “Black Straw Hats” (Brecht’s version of the Salvation Army). Joan, a lieutenant in the Black Straw Hats, is a voice for justice for the workers and in solidarity with the poor. It would be easy for audience members to become absorbed into the plot of the story and empathetically lost in Joan’s passion for justice; but Brecht does not expect the suspense of the conflict or the passion of Joan’s speeches to move the audience toward political action. For Brecht, such emotional catharsis is usually accompanied by social complacency when the play has ended.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("To keep the audience from getting too close to this story, he has pertinent news headlines from around the world announced over loudspeakers behind the audience during the dialogue, a reminder that the drama has economic and political implications on a global scale. Throughout the play, placards are obtrusively placed in front of each scene to summarize what is to follow. For example:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("TO ASSUAGE THE MISERY OF THE STOCKYARDS, THE BLACK STRAW HATS SALLY FORTH FROM THEIR MISSION HOUSE: JOAN’S FIRST DESCENT INTO THE DEPTHS."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-55",
      "id": "footnote-1836-55-backlink"
    }
  }, [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("The manner of a heading in a silent-­screen melodrama and in the terse style of a newscaster has the effect of removing the suspense of plot, and the audience is distanced from involvement in the immediate action.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Brecht’s “alienation devices” diminished the accumulation of suspense and discouraged traditional spectator involvement, thereby promoting critical reflection on the social and political implications of the play. By distancing the audience from the world of the play onstage, he challenged the audience to draw the play "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("near to the outside world.")])]), _vm._v(" "), _c('p', {
    staticClass: "H3"
  }, [_vm._v("Between Ritual and Theater")]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("Alienation devices do not mean audience disengagement or lack of interest. The play is not reduced to a flat moral fable or a dull informative illustration for political propaganda. Richard Schechner, in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Performance Theory, ")]), _vm._v("says that distancing promotes engagement. Noting Brecht’s and other dramatists’ use of distancing techniques, Schechner observes that presentational performance may decrease the suspense of plot but may increase the “tensive” nature of the performance by moving back and forth between the two poles of “Efficacy/Ritual” and “Entertainment/Theatre.” Whether a performance is called a “ritual” or “theater” depends mainly on context and function: where it is performed, by whom, and under what function. Schechner creates the following polarity:")]), _vm._v(" "), _c('p', {
    staticClass: "C3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("EFFICACY")]), _vm._v(" "), _c('span', [_vm._v("←     →")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("ENTERTAINMENT")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "bolditalic"
  }, [_vm._v("Ritual")]), _vm._v(" "), _c('span', {
    staticClass: "bolditalic"
  }, [_vm._v("Theatre")]), _c('br'), _vm._v("\tresults\t\tfun"), _c('br'), _vm._v("\tlink to an absent Other\t\tonly for those here"), _c('br'), _vm._v("\tsymbolic time\t\temphasis now"), _c('br'), _vm._v("\tperformer possessed, in trance\t\tperformer knows what s/he’s doing"), _c('br'), _vm._v("\taudience participates\t\taudience watches"), _c('br'), _vm._v("\taudience believes\t\taudience appreciates"), _c('br'), _vm._v("\tcriticism discouraged\t\tcriticism flourishes"), _c('br'), _vm._v("\tcollective creativity\t\tindividual creativity"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-56",
      "id": "footnote-1836-56-backlink"
    }
  }, [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Although we might place Sunday morning worship under the categories of “efficacy” and “ritual,” and a Broadway musical under the heading “entertainment and theater,” Schechner makes it clear that in all performances various movements of the listed characteristics take place between the two poles at different times. For Wilder, presentational forms shifted theater back to ritual, where the emphasis on now was moved to “symbolic time,” the audience’s “appreciation” moved toward “belief,” and, especially in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Our Town, ")]), _vm._v("an experience of the “only for those here” hinted at a collective “link to an absent other.” In Brecht’s epic theater, the purpose of alienation devices was to redirect theater from being “fun” private entertainment to being “collective creativity,” which brings forth “results” — such as community transformation.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Distance and the Reader: Reading as Performance")]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("As distance as an aesthetic principle began to wane in mid-­twentieth-­century philosophy, interpretation, and performance theory, its popularity increased as characteristics or devices in literary criticism. Especially in narrative criticism, distance was used to analyze the author’s control of the detachment of the reader in contrast to involvement, empathy, or concern of the reader toward characters represented in a work of literature. The degree of distance between reader and character was usually determined first by the narrator.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("A prime analysis of the function of distance in narrative is Wayne C. Booth’s “Control of ‘Distance’ in Jane Austen’s ‘Emma,’ ” in his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Rhetoric of Fiction. ")]), _vm._v("Here Booth discusses how the reader’s distance is achieved by the author toward the character Emma through sympathy and judgment, humor and comedy, the control of “inside views” of the character, dramatic irony, and the reader’s trust that the narrator and the author are “reliable.” The complexities and changing nature of the reader’s distance toward the character is expressed in Jane Austen’s description of Emma: “A heroine whom no one but myself will much like.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-57",
      "id": "footnote-1836-57-backlink"
    }
  }, [_vm._v("57")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Narrative critic Gerald Prince proposes “narratee” as a more precise term for the one being addressed by the narrator in a given narrative. He says that most critics confuse narratee with adjacent notions of receptor "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(récepteur), ")]), _vm._v("reader, and arch-­reader "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(archilecteur). ")]), _vm._v("In “Introduction to the Study of the Narratee,” he writes: “As there are often several narrators, several narratees, and several characters in the text, the complexity of the rapports and the variety of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("distances ")]), _vm._v("that are established between them can be quite complex.” Prince notes that a dialogue between narrators, narratees, and characters develops as a function of distance that separates them from each other. As the dialogue develops, so does the narration. Prince says that “these rapports and these distances determine to a great extent the way in which certain values are praised and others are rejected in the course of a narration and the way in which certain events are emphasized and others are nearly passed over in silence.” Complexities in plot or situation can result from the instability of the distances between narrator, narratee, and the characters; and the distance that separates the narratee from the ideal, virtual, or real readers can “determine the tone and the very nature of the narration.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-58",
      "id": "footnote-1836-58-backlink"
    }
  }, [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY-L2"
  }, [_vm._v("In the criticism of Booth and Prince, distance between narrators, characters, and the reader (or narratee) is determined by and contained within the text itself. In opposition, Louise Rosenblatt introduces the actual reader as being a part of the literary work. In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Literature as Exploration ")]), _vm._v("(1938), and later in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Reader, the Text, the Poem: The Transactional Theory of the Literary Work ")]), _vm._v("(1978), Rosenblatt advances a transactional theory of literature where literary experience is reciprocal between the reader and the text. She observes: “My insistence on the term transaction is a means of establishing the active role of both reader and text in interpretation, and ensures that we recognize that any interpretation is an event occurring at a particular time in a particular social or cultural context. Once the work has been evoked, it can become the object of reflection and analysis, according to the various critical and scholarly approaches.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-59",
      "id": "footnote-1836-59-backlink"
    }
  }, [_vm._v("59")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("In opposition to the New Criticism of her time, Rosenblatt argued that meaning is not found in the text alone: “A novel or poem or play remains merely inkspots on paper until a reader transforms them into a set of meaningful symbols. The literary work exists in the live circuit set up between reader and text: the reader infuses intellectual and emotional meanings into the pattern of verbal symbols, and those symbols channel his or her thoughts and feelings. Out of this complex process emerges a more or less organized imaginative experience.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-60",
      "id": "footnote-1836-60-backlink"
    }
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Whereas meaning is not located in the text, neither is it “absorbed” exclusively into the reader, as in some versions of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("subjective ")]), _vm._v("criticism and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("reader-­response ")]), _vm._v("criticism. These extreme reader-­oriented movements, with which she has sometimes mistakenly been identified, arose after Rosenblatt’s original work. She says: “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Under the guidance of the text, ")]), _vm._v("out of his own thoughts, and feelings and sensibilities, the reader makes a new ordering, the formed substance which is for him the literary work of art.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-61",
      "id": "footnote-1836-61-backlink"
    }
  }, [_vm._v("61")])]), _vm._v(" For Rosenblatt, the reader’s responses "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and ")]), _vm._v("the text are in transaction whereby the text is performed by the reader as an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("event. ")]), _vm._v("Meaning is found in that transactional event."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-62",
      "id": "footnote-1836-62-backlink"
    }
  }, [_vm._v("62")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("The reader, whether silent or aloud, who adopts an aesthetic posture toward a text is a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("performer: ")]), _vm._v("“In the evocation of literary works of art, then, the reader calls forth the thoughts, images, situations, and characters from the printed words. The complexity of the aesthetic process rests on the extent to which ‘meaning’ resides in the felt experience, in the kinesthetic sensations, the associations, the affective coloring derived from past encounters with words and their referents in life and in literature.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-63",
      "id": "footnote-1836-63-backlink"
    }
  }, [_vm._v("63")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("In transactional theory, distance is not limited to a narrative device, located within a text, that informs the empathy or detachment of the reader to characters or the narrator. Nor is it a dispassionate, detached, or aesthetic distance, such as was promoted by Kant, Bullough, and some of the New Critics. Rosenblatt cites her article “The Poem as Event” (1964) as the “first explicit attack on the New Critics that called for a criticism based on the reader’s response.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-64",
      "id": "footnote-1836-64-backlink"
    }
  }, [_vm._v("64")])]), _vm._v(" Although sympathetic with the New Critics’ concept of the intentional fallacy, in which the meaning of a text is freed from its authorial intent, she is directly opposed to their understanding of the affective fallacy, because it dismisses what a reader brings to a text and the responses evoked in the reader by the text.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Art and Engagement ")]), _vm._v("(1991), Arnold Berleant, a philosopher of aesthetics, provides a concise summary of Rosenblatt’s theory and a warrant for its continued influence:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("Transactional theory offers a significantly different direction for moving beyond this deep division of reader and text. Applying a relational model developed in theory of knowledge and psychology to the study of literary experience, Louise M. Rosenblatt regards an aesthetic encounter with literature as temporal event, to which a reader and a text make an equal contribution. This is not, however, an equal exchange; in fact it is not an exchange at all. Rather, both reader and text join in a unified occasion: The poem is not an object but an experience, one in which reader and text join. It is an event that occurs in the time of experience, to which the reader brings knowledge, background, personality, and the skills of perception and comprehension to activate the ordered symbols of the text. This is probably the fullest development of the reader-­response direction, one that comes closest to a complete integration of text and reader."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-65",
      "id": "footnote-1836-65-backlink"
    }
  }, [_vm._v("65")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("In a transactional theory of literature, integration does not mean the absorption of either the text into the reader or the reader into the text. Distance between text and reader is essential to make space for what the reader brings to a text as well as the experiences and the reflections that are evoked from the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("performance ")]), _vm._v("of reading. Such distance fosters, rather than excludes, passionate emotional engagement as well as critical appreciation, reflection, and evaluation.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Distance in Rosenblatt’s understanding of literature as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("transaction ")]), _vm._v("and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("exploration ")]), _vm._v("has significant implications for performance in general (and preaching in particular). Although Rosenblatt’s transactional theory of literature discusses the importance of the reader in the event of the poem, it also draws significant parallels with the audience in the “event” of the performance of texts. She maintains that silent reading is a “performing art,” where readers “perform in response to a text.” She writes: “The reader performs the poem or the novel as the violinist performs the sonata. But the instrument on which the reader plays, and from which he evokes the work, is — himself.” Rosenblatt then draws a correlation between reader and audience: the audience’s response to a work performed is parallel to the reader’s response to a text: “The listener makes meaning out of the sounds in a transactional process that parallels the reader’s making meaning out of the visual text.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-66",
      "id": "footnote-1836-66-backlink"
    }
  }, [_vm._v("66")])]), _vm._v(" The transactional “two-­way” relationship between the reader and text is the same dynamic in the two-­way transaction between performer and audience whereby the audience becomes performer.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("As in the case of the reader in relationship to the text, distance encourages and protects the responses of the hearer (emotions, criticism, passions, thoughts, judgments, rejections, and acceptances) as integral to the performance. As the reader is not passively absorbed into the text, neither is the hearer passively absorbed into the performance of a text (or a sermon). A transactional approach to performance transcends the text/reader–performer/hearer dichotomy whereby distance fosters not absorption but engagement."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-67",
      "id": "footnote-1836-67-backlink"
    }
  }, [_vm._v("67")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("The basis of Rosenblatt’s transactional theory is that literature is “exploration,” “lived-­through” experiences whereby the “reader seeks to participate in another’s vision — to reap knowledge of the world, to fathom the resources of the human spirit, to gain insights that will make his own life more comprehensible.” Such an exploration of literature that is dependent on the response of the reader changed her teaching from the deductive to the inductive method. She says that inductive methods of teaching “led me to differentiate between the old method, whereby leading questions were aimed at preordained conclusions, and my view, that ‘the most fruitful inductive learning arises out of the involvement of the student . . . which leads him to raise personally meaningful questions . . . [and] to seek in the text the basis for valid answers and the impetus to further inquiry.” She continues: “The problem that the teacher faces first of all, then, is the creation of a situation favorable to a vital experience of literature.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-68",
      "id": "footnote-1836-68-backlink"
    }
  }, [_vm._v("68")])]), _vm._v(" For Rosenblatt, the beginning of reading a text is the creation of space for the reader to hear, encounter, participate in, and inductively explore.")]), _vm._v(" "), _c('p', {
    staticClass: "H1",
    attrs: {
      "id": "toc_marker-4-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text1#toc8"
    }
  }, [_vm._v("Backdrop for Preaching")])]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("When Fred Craddock introduced the term “distance” as part of his homiletical method in 1978, the concept had changed significantly from Bullough’s introduction of “psychical Distance” in 1912. For Bullough, Distance was a universal aesthetic response that occurs when people psychically remove themselves from a work of art or literature. This change in perception is accomplished by perceivers suspending their personal interests, desires, feelings, and emotions, as well as any utilitarian or moral values they might be inclined to impose on the art object. Distance is obtained by “separating the object and its appeal from one’s own self by putting it out of gear with practical needs and ends.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1836-69",
      "id": "footnote-1836-69-backlink"
    }
  }, [_vm._v("69")])]), _vm._v(" The goal of a true aesthetic experience was a Kantian "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("disinterested contemplation, ")]), _vm._v("whereby form was appreciated for its balance and harmony, and beauty was enjoyed simply for its own sake.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("As universal claims in aesthetics were called into question, Bullough’s concept of Distance as an “aesthetic principle” was mainly abandoned by the latter part of the twentieth century. What continued to develop, albeit greatly transformed, was his observation of the function, or “dynamics,” of Distance as a “factor in art.” What originated in the philosophical field of aesthetics as a principle became in performance studies and literary criticism “distancing devices” and “techniques.” Distance as an aesthetic attitude, a dispassionate appreciation that was void of interest, emotion, moral values, or utilitarian purposes, had become “devices” in an inductive discovery by the reader/audience, whose purposes were complete engagement, passionate reflection, invested evaluation, emotional identification, and ethical response. For speech-­interpretation scholars such as Wallace Bacon and Leland Roloff, the dynamics of distance protected the integrity of both the text and the performer, preventing either one from being absorbed into the other. For presentational playwrights such as Thornton Wilder, distancing techniques allowed the audience to see a drama as part of something much “larger” than themselves, calling forth from the audience wonder, mystery, and belonging. In Bertolt Brecht’s epic theater, utilitarian function and ethical considerations were not stripped away but fostered as the primary purpose of performance. In these plays, intentional distancing devices, or “alienation effects,” fostered both critical reflection and emotional participation. Being prompted to step backward, the reader or hearer could then step forward into a fuller engagement with the performance’s significance to the greater community and the world. For literary critics like Louise Rosenblatt, distance becomes a negotiation between text and reader, whereby the reader’s response becomes part of the “poem” via an inductive process of discovery. From these trajectories of distance in speech, theater, and literature, I return to my initial proposal: Distance between the audience and the performer, between the performer and the text, and between the text and the audience is integral to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("preservation of the text ")]), _vm._v("and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("engagement of the hearer ")]), _vm._v("in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("performance as an event.")])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("With this as a backdrop, we can now discuss the concept of distance in preaching."), _c('span', {
    staticClass: "char-style-override-1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "footnotes"
  }, [_c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-1-backlink",
      "id": "footnote-1836-1"
    }
  }, [_vm._v("1")]), _vm._v(". Noël Carroll, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Philosophy of Art: A Contemporary Introduction ")]), _vm._v("(New York: Routledge, Taylor, and Francis Group, 2002), pp. 156, 157.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-2-backlink",
      "id": "footnote-1836-2"
    }
  }, [_vm._v("2")]), _vm._v(". Carroll, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Philosophy of Art, ")]), _vm._v("pp. 156-59; Ted Cohen and Paul Guyer, “Introduction to Kant’s Aesthetics: From Essays in Kant’s Aesthetics,” in George Dickie, Richard Sclafani, and Ronald Roblin, eds., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aesthetics: A Critical Anthology ")]), _vm._v("(New York: St. Martin’s Press, 1989), 306-7.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-3-backlink",
      "id": "footnote-1836-3"
    }
  }, [_vm._v("3")]), _vm._v(". Carroll, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Philosophy of Art, ")]), _vm._v("pp. 157-59, 202; George Dickie, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aesthetics ")]), _vm._v("(New York: Bobbs-­Merrill, 1971), p. 60. For a further discussion of “aesthetic attitude” and “aesthetic experience,” see Jerome Stolnitz, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aesthetics and Philosophy of Art Criticism: A Critical Introduction ")]), _vm._v("(Boston: Houghton Mifflin, 1960), pp. 34-83.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-4-backlink",
      "id": "footnote-1836-4"
    }
  }, [_vm._v("4")]), _vm._v(". Christopher Janaway, “ ‘Aesthetic Attitude’ and ‘Aesthetic Distance,’ ” in Ted Honderich, ed., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Oxford Companion to Philosophy ")]), _vm._v("(Oxford: Oxford University Press, 1995).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-5-backlink",
      "id": "footnote-1836-5"
    }
  }, [_vm._v("5")]), _vm._v(". Immanuel Kant, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Critique of Judgment, ")]), _vm._v("trans. Werner S. Pluhar (Indianapolis: Hackett Publishing, 1987), pp. 43-46 (originally published in Prussia in 1790).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-6-backlink",
      "id": "footnote-1836-6"
    }
  }, [_vm._v("6")]), _vm._v(". Dickie et al., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aesthetics, ")]), _vm._v("p. 27.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-7-backlink",
      "id": "footnote-1836-7"
    }
  }, [_vm._v("7")]), _vm._v(". Kant, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Critique of Judgment, ")]), _vm._v("p. 46.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-8-backlink",
      "id": "footnote-1836-8"
    }
  }, [_vm._v("8")]), _vm._v(". M. H. Abrams, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Glossary of Literary Terms ")]), _vm._v("(Fort Worth: Harcourt Brace, 1999), pp. 68-69. For further discussion regarding Kant’s aesthetic of “indifference” and “disinterested contemplation,” see Gordon Graham, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Re-­enchantment of the World: Art Versus Religion ")]), _vm._v("(New York: Oxford University Press, 2007), p. 23; Henry E. Allison, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kant’s Theory of Taste: A Reading of the Critique of Aesthetic Judgment ")]), _vm._v("(Cambridge: Cambridge University Press, 2001), pp. 85-97; and Cohen and Guyer, “Introduction to Kant’s Aesthetics,” pp. 306-14.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-9-backlink",
      "id": "footnote-1836-9"
    }
  }, [_vm._v("9")]), _vm._v(". When referring to Bullough’s work, I will follow his use of the uppercase "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("D ")]), _vm._v("for the aesthetic concept of “Distance,” in contrast to the lowercase "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("d ")]), _vm._v("for “distancing devices.”")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-10-backlink",
      "id": "footnote-1836-10"
    }
  }, [_vm._v("10")]), _vm._v(". Edward Bullough, “ ‘Psychical Distance’ as a Factor in Art and an Aesthetic Principle,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The British Journal of Psychology ")]), _vm._v("5 (June 1912): 87-118, reprinted in Bullough, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aesthetics: Lectures and Essays ")]), _vm._v("(Stanford: Stanford University Press, 1957). Hereafter, page references to this latter work appear in parentheses in the text.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-11-backlink",
      "id": "footnote-1836-11"
    }
  }, [_vm._v("11")]), _vm._v(". Susanne K. Langer, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Feeling and Form ")]), _vm._v("(New York: Scribner, 1953), p. 318.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-12-backlink",
      "id": "footnote-1836-12"
    }
  }, [_vm._v("12")]), _vm._v(". Dickie et al., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aesthetics, ")]), _vm._v("p. 47.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-13-backlink",
      "id": "footnote-1836-13"
    }
  }, [_vm._v("13")]), _vm._v(". This is also noted in Beverly Whitaker Long, “A ‘Distanced’ Art: Interpretation at Mid-­Century,” in David W. Thompson, ed., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Performance of Literature in Historical Perspectives ")]), _vm._v("(Lanham, MD: University Press of America, 1983), pp. 567-87.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-14-backlink",
      "id": "footnote-1836-14"
    }
  }, [_vm._v("14")]), _vm._v(". See also Long, “A ‘Distanced’ Art,” p. 568.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-15-backlink",
      "id": "footnote-1836-15"
    }
  }, [_vm._v("15")]), _vm._v(". Bullough’s understanding of Distance to be holding “in abeyance” the personal aspect of a character in a drama opened the door to twentieth-­century “distancing devices” and “alienation effects” used by playwrights such as Thornton Wilder and Bertolt Brecht. In literary criticism, a similar device is known as “detachment.” I will discuss these devices and techniques later in this chapter.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-16-backlink",
      "id": "footnote-1836-16"
    }
  }, [_vm._v("16")]), _vm._v(". For a discussion and critique of Bullough’s “antinomy of Distance,” see Dickie et al., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aesthetics, ")]), _vm._v("pp. 48-60.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-17-backlink",
      "id": "footnote-1836-17"
    }
  }, [_vm._v("17")]), _vm._v(". Long, “A ‘Distanced’ Art,” p. 570.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-18-backlink",
      "id": "footnote-1836-18"
    }
  }, [_vm._v("18")]), _vm._v(". Long, “A ‘Distanced’ Art,” pp. 570, 571. For an extensive discussion of underdistancing and overdistancing, see Sheila Dawson, “ ‘Distancing’ as an Aesthetic Principle,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Australasian Journal of Philosophy ")]), _vm._v("39, no. 2 (August 1961). A strong follower of Bullough, Dawson revised and reinterpreted his aesthetic of Distance for the mid-­twentieth century. In further support of Bullough’s understanding of Distance, see Sueh Pandit, “In Defense of Psychical Distance,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The British Journal of Aesthetics ")]), _vm._v("16 (1976): 56-60; see also Melvin Rader, “The Meaning of Art,” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Modern Book of Esthetics ")]), _vm._v("(New York: Holt, Rinehart, and Winston, 1979), pp. 14-17.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-19-backlink",
      "id": "footnote-1836-19"
    }
  }, [_vm._v("19")]), _vm._v(". Long, “A ‘Distanced’ Art,” p. 570.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-20-backlink",
      "id": "footnote-1836-20"
    }
  }, [_vm._v("20")]), _vm._v(". José Ortega y Gasset, “The Dehumanization of Art” (1925), from José Ortega y Gasset, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Dehumanization of Art ")]), _vm._v("(Princeton, NJ: Princeton University Press, 1948), quoted in Rader, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Modern Book of Aesthetics,")]), _vm._v(" pp. 333, 363-70; see also review by David Mandel, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Leonardo: International Journal of the Contemporary Artist ")]), _vm._v("8 (Winter 1975): 78, cited in Rader, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Modern Book of Esthetics, ")]), _vm._v("p. 333.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-21-backlink",
      "id": "footnote-1836-21"
    }
  }, [_vm._v("21")]), _vm._v(". Rader, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Modern Book of Aesthetics, ")]), _vm._v("pp. 333-34.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-22-backlink",
      "id": "footnote-1836-22"
    }
  }, [_vm._v("22")]), _vm._v(". George Dickie, “All Aesthetic Attitude Theories Fail: The Myth of the Aesthetic Attitude,” in Dickie et al., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aesthetics, ")]), _vm._v("p. 342; Dickie, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction to Aesthetics: An Analytic Approach ")]), _vm._v("(New York: Oxford University Press, 1997).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-23-backlink",
      "id": "footnote-1836-23"
    }
  }, [_vm._v("23")]), _vm._v(". Dickie, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction to Aesthetics, ")]), _vm._v("pp. 51-52.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-24-backlink",
      "id": "footnote-1836-24"
    }
  }, [_vm._v("24")]), _vm._v(". Carroll, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Philosophy of Art, ")]), _vm._v("p. 202.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-25-backlink",
      "id": "footnote-1836-25"
    }
  }, [_vm._v("25")]), _vm._v(". Abrams, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Glossary of Literary Terms, ")]), _vm._v("p. 68.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-26-backlink",
      "id": "footnote-1836-26"
    }
  }, [_vm._v("26")]), _vm._v(". For working definitions of the terms “oral interpretation,” “interpretation,” and “performance studies,” see chapter 1 above. The term “interpretation” may include the practice and theory of oral reading and oral interpretation. For clarity, I will distinguish “interpretation” with regard to the performance of texts from hermeneutical theories of interpretation by the use of the term “oral interpretation.”")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-27-backlink",
      "id": "footnote-1836-27"
    }
  }, [_vm._v("27")]), _vm._v(". Quoted in Wallace A. Bacon, “The Dangerous Shores: From Elocution to Interpretation,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Quarterly Journal of Speech ")]), _vm._v("46, no. 2 (April 1960): 149. Hereafter, page references to this journal article appear in parentheses in the text.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-28-backlink",
      "id": "footnote-1836-28"
    }
  }, [_vm._v("28")]), _vm._v(". Giles Wilkeson Gray, “What Was Elocution?” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Quarterly Journal of Speech ")]), _vm._v("46, no. 1 (1960): 2.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-29-backlink",
      "id": "footnote-1836-29"
    }
  }, [_vm._v("29")]), _vm._v(". Wilbur Samuel Howell, “Sources of the Elocutionary Movement in England, 1700-1748,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Quarterly Journal of Speech ")]), _vm._v("45 (1959): 5, cited by Gray, “What Was Elocution?” p. 2.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-30-backlink",
      "id": "footnote-1836-30"
    }
  }, [_vm._v("30")]), _vm._v(". Thomas Sheridan (1719-1788), “A Course of Lectures on Elocution” (London, 1762), cited in Bacon, “Dangerous Shores,” p. 148.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-31-backlink",
      "id": "footnote-1836-31"
    }
  }, [_vm._v("31")]), _vm._v(". Anna T. Randall, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reading and Elocution: Theoretical and Practical ")]), _vm._v("(New York: Ivison, Blakeman, Taylor, 1869), p. xiii; and William T. Ross, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Voice, Culture and Elocution ")]), _vm._v("(New York: Baker and Taylor, 1887), p. 1, cited in Gray, “What Was Elocution?” p. 3. These definitions of elocution paved the way for the early twentieth-­century designation of oral reading as “expression.”")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-32-backlink",
      "id": "footnote-1836-32"
    }
  }, [_vm._v("32")]), _vm._v(". Bacon says that in the eighteenth and nineteenth centuries, teachers of the art of speech and reading did not normally distinguish between these arts but regarded them as nearly identical.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-33-backlink",
      "id": "footnote-1836-33"
    }
  }, [_vm._v("33")]), _vm._v(". Charles L. Bartow, “In Service to the Servants of the Word: Teaching Speech at Princeton Seminary,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Princeton Seminary Bulletin ")]), _vm._v("13, no. 3 (1992): 275.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-34-backlink",
      "id": "footnote-1836-34"
    }
  }, [_vm._v("34")]), _vm._v(". Bartow, “In Service to the Servants of the Word,” p. 275.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-35-backlink",
      "id": "footnote-1836-35"
    }
  }, [_vm._v("35")]), _vm._v(". See also Gray, “What Was Elocution?” pp. 1-7.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-36-backlink",
      "id": "footnote-1836-36"
    }
  }, [_vm._v("36")]), _vm._v(". Randall, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reading and Elocution, ")]), _vm._v("pp. 1-7; Bullough, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aesthetics, ")]), _vm._v("p. 101.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-37-backlink",
      "id": "footnote-1836-37"
    }
  }, [_vm._v("37")]), _vm._v(". Randall, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reading and Elocution, ")]), _vm._v("p. 7.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-38-backlink",
      "id": "footnote-1836-38"
    }
  }, [_vm._v("38")]), _vm._v(". See also Wallace A. Bacon and Robert S. Breen, preface to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Literature as Experience ")]), _vm._v("(New York: McGraw-­Hill, 1959).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-39-backlink",
      "id": "footnote-1836-39"
    }
  }, [_vm._v("39")]), _vm._v(". Discussed in Alla Bozarth-­Campbell, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Word’s Body: An Incarnational Aesthetic of Interpretation ")]), _vm._v("(Tuscaloosa: University of Alabama Press, 1979), pp. 18-19.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-40-backlink",
      "id": "footnote-1836-40"
    }
  }, [_vm._v("40")]), _vm._v(". Wallace A. Bacon, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Art of Interpretation ")]), _vm._v("(New York: Holt, Rinehart and Winston, 1979), p. xii, cited in Bozarth-­Campbell, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Word’s Body, ")]), _vm._v("p. 18.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-41-backlink",
      "id": "footnote-1836-41"
    }
  }, [_vm._v("41")]), _vm._v(". Bacon, “Dangerous Shores,” p. 150; see also Bacon, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Art of Interpretation, ")]), _vm._v("p. xii, cited in Bozarth-­Campbell, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Word’s Body, ")]), _vm._v("p. 19.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-42-backlink",
      "id": "footnote-1836-42"
    }
  }, [_vm._v("42")]), _vm._v(". Here the term “epic” is not to be confused with the literary genre of saga.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-43-backlink",
      "id": "footnote-1836-43"
    }
  }, [_vm._v("43")]), _vm._v(". Bacon, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Art of Interpretation, ")]), _vm._v("pp. 244-46; Leland H. Roloff, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Perception and Evocation of Literature ")]), _vm._v("(Glenview, IL: Scott, Foresman, 1973), pp. 64-66.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-44-backlink",
      "id": "footnote-1836-44"
    }
  }, [_vm._v("44")]), _vm._v(". Roloff, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Perception and Evocation, ")]), _vm._v("pp. 100, 104.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-45-backlink",
      "id": "footnote-1836-45"
    }
  }, [_vm._v("45")]), _vm._v(". Long, “A ‘Distanced’ Art,” pp. 572-83.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-46-backlink",
      "id": "footnote-1836-46"
    }
  }, [_vm._v("46")]), _vm._v(". Unless otherwise noted, references to representational and presentational performance are a compilation based on the following: Charlotte Lee and Frank Galati, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oral Interpretation ")]), _vm._v("(Boston: Houghton Mifflin, 1977), pp. 383-89; Bacon, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Art of Interpretation ")]), _vm._v("pp. 244-46, 458, 500-503, 532; Jack A. Vaughn, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Drama A to Z ")]), _vm._v("(New York: Frederick Ungar, 1978), pp. 6, 57, 72, 138, 150, 214-15, and lectures at The School of Speech, Northwestern University, 1982-84.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-47-backlink",
      "id": "footnote-1836-47"
    }
  }, [_vm._v("47")]), _vm._v(". Constantine Stanislavski, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("An Actor’s Handbook, ")]), _vm._v("trans. and ed. Elizabeth Reynolds Hapgood (New York: Theatre Arts Books, 1963), pp. 119-20.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-48-backlink",
      "id": "footnote-1836-48"
    }
  }, [_vm._v("48")]), _vm._v(". Samuel Taylor Coleridge, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Biographia Literaria ")]), _vm._v("(1817), chap. 14, quoted in Vaughn, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Drama A to Z, ")]), _vm._v("pp. 214-15.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-49-backlink",
      "id": "footnote-1836-49"
    }
  }, [_vm._v("49")]), _vm._v(". This term was made popular by English drama critic George Henry Lewes (1817-1878), borrowing from French actor François René Molé. See Vaughn, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Drama A to Z, ")]), _vm._v("pp. 138-39.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-50-backlink",
      "id": "footnote-1836-50"
    }
  }, [_vm._v("50")]), _vm._v(". Vaughn, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Drama A to Z, ")]), _vm._v("p. 162.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-51-backlink",
      "id": "footnote-1836-51"
    }
  }, [_vm._v("51")]), _vm._v(". Lee and Galati, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oral Interpretation, ")]), _vm._v("p. 384.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-52-backlink",
      "id": "footnote-1836-52"
    }
  }, [_vm._v("52")]), _vm._v(". Thornton Wilder, preface to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Three Plays by Thornton Wilder: Our Town, The Skin of Our Teeth, The Matchmaker ")]), _vm._v("(New York: Bantam Books, 1961), p. xi. Hereafter, page references to this work appear in parentheses in the text.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-53-backlink",
      "id": "footnote-1836-53"
    }
  }, [_vm._v("53")]), _vm._v(". Epic theater was first developed by the German director Erwin Piscator in the late 1920s, but it has mainly become associated with the plays and techniques of Brecht, who spent time directing his work in the United States, where he significantly influenced American drama.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-54-backlink",
      "id": "footnote-1836-54"
    }
  }, [_vm._v("54")]), _vm._v(". See Vaughn, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Drama A to Z, ")]), _vm._v("pp. 8, 72; Richard Schechner, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Performance Theory ")]), _vm._v("(New York: Routledge, 1988), pp. 120-59; Beverly Whitaker Long and Mary Francis Hopkins, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Performing Literature: An Introduction to Oral Interpretation ")]), _vm._v("(Englewood Cliffs, NJ: Prentice Hall, 1982), pp. 151-53. For an in-­depth discussion by Brecht on epic theater, see “Short Description of a New Technique of Acting Which Produces an Alienation Effect,” in Michael Huxley and Noel Witts, eds., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Twentieth Century Performance Reader ")]), _vm._v("(New York: Routledge, 1996).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-55-backlink",
      "id": "footnote-1836-55"
    }
  }, [_vm._v("55")]), _vm._v(". Bertolt Brecht, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Collected Plays, ")]), _vm._v("vol. 3, part 1, trans. Ralph Manheim, ed. John Willett and Ralph Manheim (London: Methuen, 1991), p. 7.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-56-backlink",
      "id": "footnote-1836-56"
    }
  }, [_vm._v("56")]), _vm._v(". Schechner, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Performance Theory, ")]), _vm._v("pp. 120-59.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-57-backlink",
      "id": "footnote-1836-57"
    }
  }, [_vm._v("57")]), _vm._v(". Wayne C. Booth, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Rhetoric of Fiction ")]), _vm._v("(Chicago: University of Chicago Press, 1983), pp. 242-66.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-58-backlink",
      "id": "footnote-1836-58"
    }
  }, [_vm._v("58")]), _vm._v(". Gerald Prince, “Introduction to the Study of the Narratee,” in Jane P. Tompkins, ed., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reader-­Response Criticism: From Formalism to Post-­Structuralism ")]), _vm._v("(Baltimore: Johns Hopkins University Press, 1980), pp. 19-20 (italics added).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-59-backlink",
      "id": "footnote-1836-59"
    }
  }, [_vm._v("59")]), _vm._v(". Louise M. Rosenblatt, “Reaffirming "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Literature as Exploration,")]), _vm._v("” in Edmund J. Farrell and James R. Squire, eds., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Transactions with Literature: A Fifty-­Year Perspective ")]), _vm._v("(Urbana, IL: National Council of Teachers of English, 1990), p. 106.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-60-backlink",
      "id": "footnote-1836-60"
    }
  }, [_vm._v("60")]), _vm._v(". Louise M. Rosenblatt, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Literature as Exploration ")]), _vm._v("(New York: Noble and Noble, 1976), p. 25.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-61-backlink",
      "id": "footnote-1836-61"
    }
  }, [_vm._v("61")]), _vm._v(". Louise M. Rosenblatt, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Literature as Exploration ")]), _vm._v("(New York: D. Appleton-­Century, 1968), quoted in Edward Quinn, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Literary and Thematic Terms ")]), _vm._v("(New York: Checkmark Books, 2000), p. 330 (italics added).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-62-backlink",
      "id": "footnote-1836-62"
    }
  }, [_vm._v("62")]), _vm._v(". Rosenblatt, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Literature as Exploration; ")]), _vm._v("Louise M. Rosenblatt, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Reader, the Text, the Poem: The Transactional Theory of the Literary Work ")]), _vm._v("(Carbondale, IL: Southern Illinois University Press, 1978); Louise M. Rosenblatt, “Act 1, Scene 1: Enter the Reader,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Literature in Performance ")]), _vm._v("1, no. 2 (1981): 13-23; Rosenblatt, “Reaffirming "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Literature as Exploration,")]), _vm._v("” pp. 97-107.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-63-backlink",
      "id": "footnote-1836-63"
    }
  }, [_vm._v("63")]), _vm._v(". Rosenblatt, “Act 1, Scene 1: Enter the Reader,” p. 18.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-64-backlink",
      "id": "footnote-1836-64"
    }
  }, [_vm._v("64")]), _vm._v(". Rosenblatt, “Reaffirming "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Literature as Exploration,")]), _vm._v("” p. 103.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-65-backlink",
      "id": "footnote-1836-65"
    }
  }, [_vm._v("65")]), _vm._v(". Arnold Berleant, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Art and Engagement ")]), _vm._v("(Philadelphia: Temple University Press, 1991), p. 121.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-66-backlink",
      "id": "footnote-1836-66"
    }
  }, [_vm._v("66")]), _vm._v(". Rosenblatt, “Act 1, Scene 1: Enter the Reader,” pp. 13, 21.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-67-backlink",
      "id": "footnote-1836-67"
    }
  }, [_vm._v("67")]), _vm._v(". Berleant praises Rosenblatt’s transactional understanding of literature as being closest to the direction he takes in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Art and Engagement, ")]), _vm._v("p. 231.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-68-backlink",
      "id": "footnote-1836-68"
    }
  }, [_vm._v("68")]), _vm._v(". Rosenblatt, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Literature as Exploration ")]), _vm._v("(1976),"), _c('em', {
    staticClass: "italic"
  }), _vm._v("pp. 7, ix-­x, 61.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1836-69-backlink",
      "id": "footnote-1836-69"
    }
  }, [_vm._v("69")]), _vm._v(". Edward Bullough, “ ‘Psychical Distance’ as a Factor in Art and an Aesthetic Principle,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The British Journal of Psychology ")]), _vm._v("5 (June 1912): 87-118, reprinted in Bullough, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aesthetics: Lectures and Essays,")]), _vm._v(" p. 96.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-433ba68d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Brothers_Distance_in_Preaching_text-3.vue
// module id = 72
// module chunks = 0